import React from 'react';

export interface BillFromQBOProps {
  companyName?: string | null;
}

const BillFromQBO: React.FC<BillFromQBOProps> = ({ companyName }): JSX.Element => {
  if (!companyName) {
    return <></>;
  }
  return (
    <>
      <span className="create-invoice__bill-title">Bill from</span>
      <span className="create-invoice__bill-name">{companyName}</span>
    </>
  );
};

export default BillFromQBO;
